import React, { useContext, useEffect, useRef, useState } from 'react';
import './voucher.css';
import { INSTANCE_WHITE_LOGO_URL as logo } from '../../components/ui/InstanceLogo';
import { MenuQRContext } from '../../context/menu/MenuQRContext';
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from 'react-to-print';
import Message from '../../components/ui/Message';
import moment from 'moment';

type Props = {
    logoUrl: string | null;
    merchant: any;
    order: any;
    table: any;
    currency: string;
    subtotal: number;
    iva: number;
    otros: number;
    total: number;
    getFormatAmount: (value: number) => string;
};

const InvoicePage: React.FC = () => {
    const [logoUrl, setLogoUrl] = useState<string | null>(null);
    const { order, table, merchant, isLoading, token, clearProduct, cancelOrder } = useContext(MenuQRContext);
    const navigate = useNavigate();

    const [currency, setCurrency] = useState<string>("188");
    const [subtotal, setSubtotal] = useState<number>(0);
    const [iva, setIva] = useState<number>(0);
    const [otros, setOtros] = useState<number>(0);
    const [total, setTotal] = useState<number>(0);
    const [message, setMessage] = useState<string>("");
    const [messageSuccess, setMessageSuccess] = useState<string>("");
    const [customCancel, setCustomCancel] = useState<boolean>(false);
    const [isButtonEnabled, setIsButtonEnabled] = useState(true);
    const [counter, setCounter] = useState(15);

    useEffect(() => {
        if (counter > 0) {
            const interval = setInterval(() => {
                setCounter((prev) => prev - 1);
            }, 1000);

            return () => clearInterval(interval);
        } else {
            setIsButtonEnabled(false);
            setMessage("");
        }
    }, [counter]);

    const componentRef = useRef<HTMLDivElement>(null);

    const removeError = () => {
        setMessage('');
    }


    const removeMessageSuc = () => {
        setMessageSuccess('');
    }


    const goToHome = () => {
        clearProduct();
        navigate('/menuqr/' + token, { replace: true });
    }



    const removeOrder = async () => {
        const resp = await cancelOrder();
        setCustomCancel(false);
        if (resp == 'success') {
            setMessageSuccess("La orden se canceló exitosamente.");

        } else {
            setMessage(resp);
        }
    }





    useEffect(() => {
        if (order != null) {
            let vSubtotal = 0;
            let vTax = 0;

            order.products.forEach((product) => {
                vSubtotal += product.price * product.quantity;
                vTax += (product.price * product.quantity) * (product.tax / 100);
            });

            if (merchant?.simplifiedRegime) {
                vTax = 0;
            }

            const vOtros = vSubtotal * 0.1;
            const vTotal = vSubtotal + vTax + vOtros;

            setSubtotal(vSubtotal);
            setIva(vTax);
            setOtros(vOtros);
            setTotal(vTotal);
        }
    }, [order, merchant]);

    const closePage = async () => {
        setMessage("Desea cerrar está página?")
    };

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
        pageStyle: ``,
        //onAfterPrint: closePage

    });

    const handlePay = async () => {
        handlePrint();
    };


    const handleCancel = async () => {
        if (isButtonEnabled) {
            setCustomCancel(true);
            setMessage("Desea cancelar la orden?");
        }

    };

    const getFormatAmount = (value: number): string => {
        return new Intl.NumberFormat('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    };

    useEffect(() => {
        setLogoUrl(logo);
    }, []);

    return (
        <div>
            {isLoading ? (
                <div className="d-flex justify-content-center">
                    <div className="spinner-border text-info mt-5" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : !merchant ? (
                <div className="wrapper1">
                    <div className="headerLogin">
                        <img src={logoUrl || ''} alt="Logo" className="logo" />
                    </div>
                    <div className="container-voucher my-5">
                        <p>Ocurrió un error procesando la solicitud</p>
                    </div>
                </div>
            ) : (

                <div>
                    <div style={{
                        top: '12%',
                        right: '5.2%',
                        position: 'absolute'
                    }}><button type="button" className="btn btn-success" title="Guardar" onClick={handlePay}><i className="bi bi-save"></i> Guardar</button></div>
                    <ComponentToPrint
                        ref={componentRef}
                        logoUrl={logoUrl}
                        merchant={merchant}
                        order={order}
                        table={table}
                        currency={currency}
                        subtotal={subtotal}
                        iva={iva}
                        otros={otros}
                        total={total}
                        getFormatAmount={getFormatAmount}
                    />
                </div>

            )}

            <div style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                backgroundColor: '#fff',
                padding: '10px',
                boxShadow: '0 -2px 5px rgba(0,0,0,0.1)',
                zIndex: 999
            }} className="d-flex justify-content-center">
                <button
                    type="button"
                    onClick={handleCancel}
                    className="btn btn-danger w-75"
                    disabled={!isButtonEnabled}
                >
                    <span>Cancelar</span>
                    {isButtonEnabled && (
                        <span className="badge bg-secondary ms-2">{counter}s</span>
                    )}
                </button>

                <div className='me-5' />
                <button
                    type="button"
                    onClick={goToHome}
                    className="btn btn-primary w-75"
                >
                    Ir al Menú
                </button>
            </div>
            {
                message.length > 0
                    ?
                    customCancel
                        ?
                        <Message type='error' message={message} closeDialog={removeError} handleOk={removeOrder} showCancel={true} cancelText='No' okText='Si' handleCancel={removeError} />
                        : <Message type='error' message={message} closeDialog={removeError} handleOk={removeError} />
                    : ''
            }
            {
                messageSuccess.length > 0 ?
                    < Message type='error' message={message} closeDialog={removeMessageSuc} handleOk={goToHome} />
                    : ''
            }
        </div>
    );
};

const ComponentToPrint = React.forwardRef<HTMLDivElement, Props>((props, ref) => (
    <div ref={ref}>
        <div className="wrapper1">
            <div className="headerLogin">
                <img src={props.logoUrl || ''} alt="Logo" className="logo" />
            </div>
            <div className="container-voucher my-5">
                <div className="row">
                    <div className="col-md-10 mx-auto">
                        <div>
                            <div className="mb-4" style={{ marginTop: '15px' }}>
                                <h4 className='text-center'>{props.merchant.name}</h4>
                                {props.merchant.phone && <p>Teléfono: {props.merchant.phone}</p>}
                                {props.merchant.email && <p>Correo: {props.merchant.email}</p>}
                                <p>Dirección: {props.merchant.address}</p>
                            </div>

                            <h5 className="mt-5 mb-3 text-center">Detalles de la Orden</h5>
                            <p style={{ padding: 0, margin: '3px' }}><strong>Número de Orden:</strong> {props.order.orderNumber}</p>
                            <p style={{ padding: 0, margin: '3px' }}><strong>Mesa:</strong> {props.table.name}</p>
                            <p style={{ padding: 0, margin: '3px' }}><strong>Fecha:</strong> {moment().format("DD/MM/yyyy hh:MM A")}</p>


                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead className="bg-secondary text-white">
                                        <tr>
                                            <th>Producto</th>
                                            <th>Cantidad</th>
                                            <th style={{ textAlign: 'right' }}>Precio Unitario</th>
                                            <th style={{ textAlign: 'right' }}>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.order.products.map((detail) => (
                                            <tr key={detail.id}>
                                                <td style={{ width: '250px' }}>{detail.name}</td>
                                                <td>{detail.quantity}</td>
                                                <td style={{ textAlign: 'right' }}>
                                                    {props.getFormatAmount(detail.price)}
                                                </td>
                                                <td style={{ textAlign: 'right' }}>
                                                    {props.getFormatAmount(detail.quantity * detail.price)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <table style={{ width: '100%' }}>
                                <tbody>
                                    <tr>
                                        <th colSpan={3} style={{ textAlign: 'right' }}>Subtotal:</th>
                                        <td style={{ textAlign: 'right' }}><strong>{props.getFormatAmount(props.subtotal)}</strong></td>
                                    </tr>
                                    <tr>
                                        <th colSpan={3} style={{ textAlign: 'right' }}>IVA:</th>
                                        <td style={{ textAlign: 'right' }}><strong>{props.getFormatAmount(props.iva)}</strong></td>
                                    </tr>
                                    <tr>
                                        <th colSpan={3} style={{ textAlign: 'right' }}>Otros cargos:</th>
                                        <td style={{ textAlign: 'right' }}><strong>{props.getFormatAmount(props.otros)}</strong></td>
                                    </tr>
                                    <tr>
                                        <th colSpan={3} style={{ textAlign: 'right' }}>Total:</th>
                                        <td style={{ textAlign: 'right' }}><strong>{props.getFormatAmount(props.total)}</strong></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
));

export default InvoicePage;
